import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import EmailPopup from "./components/EmailPopup";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import MeetBuddies from "./pages/MeetBuddies";
import BuddyDetail from "./pages/BuddyDetail";
import HowItWorks from "./pages/HowItWorks";
import Stories from "./pages/Stories";
import ForParents from "./pages/ForParents";
import OurStory from "./pages/OurStory";
import Safety from "./pages/Safety";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Checkout from "./pages/Checkout";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import FindBuddy from "./pages/FindBuddy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1 });
    const raf = (t) => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/buddies" element={<MeetBuddies />} />
          <Route path="/buddy/:slug" element={<BuddyDetail />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/for-parents" element={<ForParents />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<Account />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/find-your-buddy" element={<FindBuddy />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <EmailPopup />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell />
          <Toaster position="bottom-center" toastOptions={{ style: { background: "#FFFFFF", color: "#102A56", border: "1px solid #FBE7EF", borderRadius: "1rem", boxShadow: "0 10px 40px rgba(16,42,86,0.12)" } }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
